/* jshint esversion: 6 */
import { filter, mergeMap } from 'rxjs/operators';
import api from 'app/redux/api.js';
import {
    PostGroupActions
} from 'app/redux/actions.js';
import * as constants from 'app/redux/constants.js';


export const fetchPostGroupsEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.POSTGROUP_LIST && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, null, PostGroupActions.receivePostGroups))
);

export const fetchPostGroupEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.POSTGROUP_SHOW && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, action.id, null, PostGroupActions.receivePostGroup))
);

export const updatePostGroupEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.POSTGROUP_UPDATE && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, PostGroupActions.updatedPostGroup))
);

export const deletePostGroupEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.POSTGROUP_DELETE && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, action.id, null, PostGroupActions.deletedPostGroup))
);

export const createPostGroupEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.POSTGROUP_CREATE && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, PostGroupActions.createdPostGroup))
);
